import React from 'react';
import { useMods } from '../lib/mods';
import styled from 'styled-components/macro';
import { FaLink } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { VersionIndicator } from '../components/versionIndicator';

const ModsContainer = styled.div`
  flex: 1;
  flex-direction: column;
  text-align: left;
  overflow-y: scroll;
  height: 100%;
`;

const StyledLinkIcon = styled.a`
  cursor: pointer;
  margin: 0 1rem;
  color: ${(props) => props.theme.colors.tfpWhite};
  &:hover {
    color: ${(props) => props.theme.colors.tfpRed};
  }
`;

function ModLink({ url }) {
  if (!url) return null;

  return (
    <StyledLinkIcon href={url} target="_blank" rel="noopener noreferrer">
      <FaLink />
    </StyledLinkIcon>
  );
}

ModLink.propTypes = {
  url: PropTypes.string.isRequired,
};

export function Mods() {
  const { mods } = useMods();

  if (!mods) {
    return <p>Mods still loading...</p>;
  }

  const modsList = mods
    .filter((mod) => mod.displayName)
    .map((mod) => {
      return (
        <div key={mod.name}>
          <h2>
            {mod.displayName}
            <ModLink url={mod.website} />
          </h2>
          <small>
            Author: {mod.author}, version: {mod.version}
          </small>
          <p>{mod.description}</p>
        </div>
      );
    });

  return (
    <ModsContainer>
      <h1>Mods</h1>

      <h2>Dashboard version</h2>
      <VersionIndicator />

      {modsList}
    </ModsContainer>
  );
}
